/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {BedroomParentOutlined, PointOfSaleOutlined} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Reserva_Abono_Individual from "./Formulario_Reserva_Abono_Individual";
import {Tarjeta_Abono} from "../../Tarjetas/Tarjeta_Abono";
import Valores_Reservas from "../../Componentes/Valores_Reservas";

const Formulario_Reserva_Abonos = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'abonos',
        nombre: 'Abonos',
        Formulario: Formulario_Reserva_Abono_Individual,
        Tarjeta: Tarjeta_Abono,
    })


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Valores_Reservas props={props}/>
                </Grid>


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={BedroomParentOutlined} nombre={'# Suite'} dato={'numero'}
                                  editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 8}}>
                    <IngresarObjeto/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Notas Internas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Notas Internas'} dato={'notas'} {...props}
                                  lineas={6}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Abonos